export default {
    excel: 0,
    pdf: 1,
    text: 2,
    csv: 3
}